<!-- GPR Spinner -->

<div data-test="gprSpinner" *ngIf="showLoader" class="spinner-overlay">
  <object class="m-auto" data="../assets/img/gpr-spinner-blocks.svg" height="180px" type="image/svg+xml" width="180px">
    <img data-test="spinner" alt="" class="m-auto" height="180" src="../assets/img/gpr-spinner-blocks.gif" width="180">
  </object>
</div>

<ng-container *ngIf="authService.isLoggedIn()">
  <!-- Header component (hidden during preview print windows) -->
  <app-header *ngIf="!isPrintPreview()"></app-header>

  <!-- component load section -->
  <div class="app-wrapper">
    <router-outlet></router-outlet>
  </div>

  <!-- footer section (hidden during preview print windows) -->
  <app-footer *ngIf="!isPrintPreview()"></app-footer>

  <router-outlet name="print"></router-outlet>
</ng-container>
